<template>
  <div class="intentionOrder" >
    <el-tabs  type="border-card" v-model="activeName">
      <el-tab-pane label="发起订单" name="one">
        <OrderList falg='1' :orderData="orderData1"/>
      </el-tab-pane>
      <el-tab-pane v-if="user.authent*1" label="收到订单" name="two" >
        <OrderList falg='0' :orderData="orderData2" @initReceived='initReceived'/>
      </el-tab-pane>
    </el-tabs>
    
  </div>
</template>

<script>
import OrderList from "./orderList";
import { reqMyOrderTo, reqMyOrderGet } from "../../../../api";
import { mapState } from "vuex";
export default {
  components:{
    OrderList,
  },
  data(){
    return{
      activeName:'one',
      orderData1:{
        form:[
          {title:'规格/型号',key:'pro_specification_type'},
          {title:'数量',key:'amount'},
          {title:'收货地点',key:'address'},
          {title:'单价',key:'pro_price'},
          {title:'下单时间',key:'ctime'},
        ],
        column:[
          {title:'展品图',key:'img_url',falg:0,width:100},
          {title:'展品名称',key:'proname_cn',falg:1,width:'auto'},
          {title:'展商名称',key:'corpname_cn',falg:1,width:'auto'},
          {title:'状态',key:'status',falg:2,width:120},
        ],
        list:[]
      },
      orderData2:{
        form:[
          {title:'展品名称',key:'proname_cn'},
          {title:'数量',key:'amount'},
          {title:'收货地点',key:'address'},
          {title:'电话',key:'mobile'},
          {title:'下单时间',key:'ctime'},
          {title:'邮箱',key:'email'},
        ],
        column:[
          {title:'头像',key:'img',falg:0,width:100},
          {title:'收货人',key:'name',falg:1,width:'auto'},
          {title:'所属企业',key:'corpname',falg:1,width:'auto'},
          {title:'状态',key:'status',falg:3,width:120},
        ],
        list:[]
      }
    }
  },
  mounted(){
    this.initHair()
    this.initReceived()
  },
  methods:{
    async initHair(){
      const response = await reqMyOrderTo()
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,0)
      }
    },
    async initReceived(){
      const response = await reqMyOrderGet()
      if (response.code*1==2) {
        // this.orderData1.list=response.reslist
        this.sorting(response.reslist,1)
      }
    },
    sorting(arr,key){
      arr.forEach(item => {
        if (!item.pro_price) {
          item.pro_price='面议'
        }
        if (!item.name) {
          item.name=item.nickname
        }
      });
      if (key) {
        this.orderData2.list=arr
      }else{
        this.orderData1.list=arr
      }
    },
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
}
</script>

<style scoped>
  .intentionOrder{
    max-width: 1200px;
    margin: auto;
  }
</style>